import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

interface Creation {
  // From Me
  src: string;
  title: string;
  category: string;
  // From Carl
  parentId: string;
  imageTitle: string;
  imageName: string[];
  imagePath: string;
  imageAlt: string;
  imagePriority: null;
  pageId: string;
  imageTag: string[];
}

@Injectable({
  providedIn: 'root',
})
export class CreationsService {
  private apiUrl = environment.apiImageUrl;

  constructor(private http: HttpClient) {}

  getCreations(): Observable<Creation[]> {
    let params = new HttpParams().set('action', 'CMSImageContent');
    return this.http.get(this.apiUrl, { params }).pipe(
      map((response) => {
        // Assuming the array of creations is inside a property called 'data'
        return response['cmsCont'] || []; // Adjust 'data' based on actual response structure
      }),
      map((creations: any[]) =>
        creations.map((creation) => ({
          ...creation,
          category: this.mapCategory(creation.imageTag[0]),
        }))
      )
    );
  }

  private mapCategory(title: string): string {
    const categoryMap = {
      'media walls': 'Media Walls',
      'drinks bars': 'Drinks Bars',
      offices: 'Offices',
      wardrobes: 'Wardrobes',
    };
    return categoryMap[title.toLowerCase()] || 'Others';
  }
}
